import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from './App.vue'
import router from './router'

// 设计令牌须先于 Element Plus 样式引入，确保 CSS 变量覆盖生效
import './styles/tokens.scss'
import 'element-plus/dist/index.css'
import './styles/element-overrides.scss'

// Quill 富文本编辑器的 snow 主题样式：提供工具栏图标字体、.ql-editor 排版与占位符。
// 缺失会导致工具栏显示为空白方框、编辑区出现无样式的占位/三角符号。
import 'quill/dist/quill.snow.css'

import '@/utils/request'
import UmActions from '@/components/UmActions.vue'

const app = createApp(App)

// 操作列通用组件：主操作直显、其余自动收进「更多」，列宽恒定防溢出
app.component('UmActions', UmActions)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia())
app.use(router)
app.use(ElementPlus)

// 全局运行时错误兜底：把未捕获的渲染错误显示到页面，避免整页静默空白
app.config.errorHandler = (err, instance, info) => {
  // 401「登录失效」已由响应拦截器统一处理（清登录态 + 跳登录页 + 轻提示）。
  // onMounted 等钩子内未 catch 的 await 会冒到这里，若不跳过会在跳转瞬间多弹一条红条。
  if (err && err.isAuthError) return
  console.error('[app error]', info, err)
  const msg = (err && err.message) || String(err)
  let bar = document.getElementById('global-error-bar')
  if (!bar) {
    bar = document.createElement('div')
    bar.id = 'global-error-bar'
    bar.style.cssText =
      'position:fixed;left:0;right:0;top:0;z-index:99999;background:#c0392b;color:#fff;' +
      'font:13px/1.6 monospace;padding:8px 14px;white-space:pre-wrap;box-shadow:0 2px 8px rgba(0,0,0,.3)'
    document.body.appendChild(bar)
  }
  bar.textContent = '运行时错误：' + msg + '  (' + info + ')'
}

// 生命周期钩子之外的「未处理 Promise 拒绝」兜底：同样只静默登录失效（401），其余照常暴露，
// 避免每个页面都去补 try/catch 才能消除 401 带来的控制台噪音。
window.addEventListener('unhandledrejection', (e) => {
  if (e && e.reason && e.reason.isAuthError) e.preventDefault()
})

app.mount('#app')
